
const iso = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const mockRooms = [
  {
    id: "r10001",
    number: "10001",
    type: "Deluxe Rooms",
    capacity: 2,
    status: "AVAILABLE",
  },
  {
    id: "r102",
    number: "102",
    type: "Deluxe Rooms",
    capacity: 2,
    status: "OCCUPIED",
  },
  {
    id: "r103",
    number: "103",
    type: "Deluxe Rooms",
    capacity: 3,
    status: "OCCUPIED",
  },
  {
    id: "r201",
    number: "201",
    type: "Standard Rooms",
    capacity: 2,
    status: "OCCUPIED",
  },
  {
    id: "r202",
    number: "202",
    type: "Standard Rooms",
    capacity: 1,
    status: "MAINTENANCE",
  },
  {
    id: "r203",
    number: "203",
    type: "Standard Rooms",
    capacity: 2,
    status: "AVAILABLE",
  },
];

export const mockStays = [
  {
    id: "s1",
    roomId: "r102",
    tenantName: "Arun Kumar ddddd",
    phone: "9876543210",
    checkIn: iso(-2),
    checkOut: iso(3),
    status: "CHECKED_IN",
    guests: 2,
    notes: "Paid advance",
    guestDetails: [
      {
        id: 1,
        guestName: "Arun poodd",
        age: 22,
        phoneNumber: "9876543210",
      },
      {
        id: 2,
        guestName: "Guest 2",
        age: 23,
        phoneNumber: "",
      },
    ],
  },
  {
    id: "s2",
    roomId: "r103",
    tenantName: "Rahul Menon",
    phone: "9876501234",
    checkIn: iso(1),
    checkOut: iso(6),
    status: "CONFIRMED",
    guests: 2,
    notes: "",
    guestDetails: [
      {
        id: 3,
        guestName: "Rahul Menon",
        age: 24,
        phoneNumber: "9876501234",
      },
      {
        id: 4,
        guestName: "Guest 2",
        age: 22,
        phoneNumber: "",
      },
    ],
  },
  {
    id: "s3",
    roomId: "r201",
    tenantName: "Nikhil Das",
    phone: "9895012345",
    checkIn: iso(-1),
    checkOut: iso(2),
    status: "CHECKED_IN",
    guests: 1,
    notes: "Late checkout requested",
    guestDetails: [
      {
        id: 5,
        guestName: "Nikhil Das",
        age: 21,
        phoneNumber: "9895012345",
      },
    ],
  },
  {
    id: "s4",
    roomId: "r203",
    tenantName: "Joel Thomas",
    phone: "9447012345",
    checkIn: iso(4),
    checkOut: iso(8),
    status: "PENDING",
    guests: 1,
    notes: "",
    guestDetails: [
      {
        id: 6,
        guestName: "Joel Thomas",
        age: 25,
        phoneNumber: "9447012345",
      },
    ],
  },
];

export const mockSummary = {
  totalRooms: mockRooms.length,

  occupiedRooms: mockRooms.filter(
    (room) => room.status === "OCCUPIED"
  ).length,

  availableRooms: mockRooms.filter(
    (room) => room.status === "AVAILABLE"
  ).length,

  arrivals: mockStays.filter(
    (stay) => stay.checkIn === iso(0)
  ).length,

  departures: mockStays.filter(
    (stay) => stay.checkOut === iso(0)
  ).length,
};

export const mockOccupancyResponse = {
  rooms: mockRooms,
  stays: mockStays,
  summary: mockSummary,
};
